import React, { useState } from "react";
import axios from "axios";
import NibsLogo from "./assets/nibss.png";
import Logo from "./assets/v2n.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { toast } from "react-toastify";
import { base } from "./utils";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { setIsLoggedIn, setCustomSession } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    formData.append("username", username.trim());
    formData.append("password", password.trim());
    try {
      const { data } = await axios.post(
        `${base}/API/internalnibss/Authenticate.php`,
        formData
      );
      if (data.status === "SUCCESSFUL") {
        navigate("/");
        localStorage.setItem("exp", data?.data?.tokenExpiresAt);
        localStorage.setItem("token", data?.data?.token);
        localStorage.setItem("accessKey", data?.data?.accessKey);
        console.log(data);
        

        setIsLoggedIn(true);
        const customSession = data?.data?.tokenExpiresAt;
        localStorage.setItem("customSession", data?.data?.tokenExpiresAt);

        setCustomSession(customSession);
      } else {
        toast.error("Unauthorized credentials");
      }
    } catch (error) {
      toast.error("There was an error: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section>
      <div className="grid grid-cols-1 md:grid-cols-2 h-screen">
        <div className="bg-coverImg h-screen bg-no-repeat bg-cover relative hidden md:block">
          <img
            src={NibsLogo}
            alt="logo"
            className="z-50 absolute top-4 left-4 h-20 w-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black to-black/50 opacity-50"></div>
          <div className="absolute inset-0 flex items-center justify-center px-10">
            <div className="grid grid-cols-1 place-items-center text-white bg-red-700/50 rounded-se-lg rounded-xl px-16 py-4">
              <h1 className="text-2xl max-w-sm text-center w-full xl:text-6xl">
                NIP TRANSACTION PORTAL
              </h1>
            </div>
          </div>
        </div>
        <main className="flex flex-col justify-center items-center bg-green-50">
          <div className="relative mb-4">
            <img src={Logo} alt="logo" className="h-20 w-full mb-6" />
            {/* <h3 className="text-left text-4xl text-red-700">
              Enter Credentials
            </h3> */}
          </div>
          <form
            className="flex flex-col mt-4 w-full px-14 login-form"
            onSubmit={handleLogin}
          >
            <div className="mb-4 py-8">
              <label className="block text-sm font-medium text-red-500">
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
                style={{ outline: "none" }}
                required
              />
            </div>
            <div className="mb-4 relative password-input">
              <label className="block text-sm font-medium text-red-500">
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
                style={{ outline: "none" }}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-8 right-0 pr-3 flex items-center text-sm leading-5 password-toggle"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
            <button
              type="submit"
              className="bg-red-700 text-white px-4 py-2 rounded-md"
              disabled={isLoading}
            >
              {isLoading ? <div className="spinner"></div> : "Login"}
            </button>
          </form>
        </main>
      </div>
    </section>
  );
};

export default Login;
